type TextObj = {
  [index: string]: string;
};

export const RejectInfo: TextObj = {
  screening: "By Screening",
  policy: "By Manager",
  reported: "By User Report",
  reEncoding: "Re-Encoding",
};

export const FailsInfo: TextObj = {
  video: "Video",
  file: "Project File",
  image: "Thumbnail",
  description: "Description",
};

export const StatusText: TextObj = {
  All: "All",
  ACTIVATED: "Activated",
  SUSPENDED: "Suspended",
  TO_BE_DELETED_BY_USER: "To Be Deleted by User",
  TO_BE_DELETED_BY_ADMIN: "To Be Deleted by Admin",
  DELETED: "Deleted",
  RESET_DEVICE: "Reset Device",
};

export const StatusColor: TextObj = {
  ACTIVATED: "#07A499",
  SUSPENDED: "#B3261E",
  TO_BE_DELETED_BY_USER: "#6750A4",
  TO_BE_DELETED_BY_ADMIN: "#8C1D18",
  DELETED: "#787579",
};

export const StatusColorHistory: TextObj = {
  Activated: "#07A499",
  Suspended: "#B3261E",
  "Suspended indefinitely": "#B3261E",
  "To Be Deleted by User": "#6750A4",
  "To Be Deleted by Admin": "#8C1D18",
  Deleted: "#787579",
};

export const SignupText: TextObj = {
  All: "All",
  Email: "Mail",
  GOOGLE: "Google",
  APPLE: "Apple",
  FACEBOOK: "Facebook",
  WeChat: "WeChat",
};

export const StatusQueryObj: TextObj = {
  All: "All",
  Activated: "ACTIVATED",
  Suspended: "SUSPENDED",
  "To Be Deleted by User": "TO_BE_DELETED_BY_USER",
  "To Be Deleted by Admin": "TO_BE_DELETED_BY_ADMIN",
};

export const ReviewStatusColor: TextObj = {
  InReview: "#000000",
  Published: "#d0e1f3",
  Rejected: "#efefef",
};

export function getKeyByValue(obj: any, value: string) {
  return Object.keys(obj).find((key) => obj[key] === value);
}
